import classnames from "classnames";
import * as I from "immutable";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {Modal} from "react-bootstrap";

import {isDesktop, noop} from "utils";

export default class ModalForm extends Component {
  static defaultProps = {
    btnCancelClassName: "btn-default",
    btnCancelLabel: "Cancel",
    btnExtraDisabled: false,
    btnHelpTextRenderer: noop,
    btnSubmitClassName: "btn-success",
    btnSubmitDisabled: false,
    btnSubmitLabel: "Submit",
    errors: I.Map(),
  }
  static propTypes = {
    btnCancelClassName: PropTypes.string,
    btnCancelLabel: PropTypes.string,

    btnExtraClassName: PropTypes.string,
    btnExtraDisabled: PropTypes.bool,
    btnExtraLabel: PropTypes.string,

    btnHelpText: PropTypes.string,
    btnHelpTextClassName: PropTypes.string,

    btnSubmitClassName: PropTypes.string,
    btnSubmitDisabled: PropTypes.bool,
    btnSubmitLabel: PropTypes.string,

    children: PropTypes.node.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    errors: PropTypes.instanceOf(I.Map),

    modal: PropTypes.bool,
    modalBodyClassName: PropTypes.string,
    modalDialogClassName: PropTypes.string,
    modalTitle: PropTypes.string,

    onCancel: PropTypes.func.isRequired,
    onExtraSubmit: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,

    pageTitle: PropTypes.string,
  }

  renderButtons() {
    const {
      btnCancelClassName,
      btnCancelLabel,
      btnExtraClassName,
      btnExtraDisabled,
      btnExtraLabel,
      btnHelpText,
      btnHelpTextClassName,
      btnSubmitClassName,
      btnSubmitDisabled,
      btnSubmitLabel,
      modal,
      onCancel,
      onExtraSubmit,
      onSubmit,
    } = this.props;

    const btnClassName = modal ?
      "erg-margin-left-5 pull-right" :
      !isDesktop() && "btn-block";
    const cancelClassName = !modal ? "pull-right" : null;

    let helpText;
    if (btnHelpText) {
      helpText = (
        <span
          className={classnames("HelpText", btnHelpTextClassName)}
          key="help-text">
          {btnHelpText}
        </span>
      );
    }

    let extraButton;
    if (btnExtraLabel) {
      extraButton = (
        <button
          className={classnames("btn", btnExtraClassName, btnClassName)}
          disabled={btnExtraDisabled}
          key="extra"
          onClick={onExtraSubmit}
          type="submit">
          {btnExtraLabel}
        </button>
      );
    }

    const buttons = [
      helpText,
      extraButton,
      <button
        className={classnames("btn", btnSubmitClassName, btnClassName)}
        disabled={btnSubmitDisabled}
        key="submit"
        onClick={onSubmit}
        type="submit">
        {btnSubmitLabel}
      </button>,
      <button
        className={classnames("btn", btnCancelClassName, btnClassName, cancelClassName)}
        key="cancel"
        onClick={onCancel}>
        {btnCancelLabel}
      </button>,
    ];

    if (modal) {
      return buttons;
    }

    return (
      <div className="erg-margin-top-15 form-horizontal">
        <div className="form-group">
          <div className="col-xs-12 col-sm-offset-3 col-sm-9">
            {buttons}
          </div>
        </div>
      </div>
    );
  }

  renderModal() {
    const {
      children,
      modalBodyClassName,
      modalDialogClassName,
      modalTitle,
      onCancel,
      onSubmit,
    } = this.props;
    return (
      <Modal
        dialogClassName={modalDialogClassName}
        onHide={onCancel}
        show>
        <form onSubmit={onSubmit}>
          {modalTitle &&
            <Modal.Header closeButton>
              <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>}
          <Modal.Body className={modalBodyClassName}>
            {children}
          </Modal.Body>
          <Modal.Footer>
            {this.renderButtons()}
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const {children, modal, onSubmit, pageTitle} = this.props;
    if (modal) {
      return this.renderModal();
    }

    return (
      <form className="erg-margin-15" onSubmit={onSubmit}>
        {pageTitle &&
          <h1 className="erg-margin-bottom-15 erg-margin-top-0">
            {pageTitle}
          </h1>}
        {children}
        {this.renderButtons()}
      </form>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/ModalForm.js
 **/